import { MdHome } from "react-icons/md"; // Main Navigation Icon
import { HiOutlineUserGroup, HiOutlineUserAdd } from "react-icons/hi"; // Lead Icons
import {
  can_view_leads,
  can_view_leads_details,
} from "helper/permissionsCheck";

// Define icons
const icons = {
  navigation: MdHome, // General Navigation icon
  allLeads: HiOutlineUserGroup, // Icon for All Leads
  addLead: HiOutlineUserAdd, // Icon for Adding a Lead
};

// Define Leads menu based on permissions
const leadsMenu =
can_view_leads || can_view_leads_details 
    ? {
      id: "leads-group",
      title: "Leads",
      icon: icons.allLeads,
      type: "group",
      children: [
        (can_view_leads) && {
          id: "all-leads",
          title: "All Leads",
          type: "item",
          url: "/leads/all-leads",
          icon: icons.allLeads,
          breadcrumbs: true,
        },
        // can_add_users && {
        //   id: "add-lead",
        //   title: "Add Lead",
        //   type: "item",
        //   url: "/leads/add-lead",
        //   icon: icons.addLead,
        //   breadcrumbs: true,
        // },
      ].filter(Boolean),
    }
    : null;

export default leadsMenu;
